import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IStatusMessage, ResponseStatus } from '../../../shared';
import { PayrollCode } from '../store';
import * as fromShared from '../../../shared';
import { IShowErrors } from '../../../shared/errors-sidenav';

@Component({
    selector: 'ef-payroll-codes',
    templateUrl: './payroll-codes.component.html',
    styleUrls: ['./payroll-codes.component.scss'],
    standalone: false
})
export class PayrollCodesComponent {
    dropdownItemHeight = environment.dropdownItemHeight;
    public editing?: PayrollCode = {} as PayrollCode;
    selected: PayrollCode[] = [];
    cloned: { [i: number]: PayrollCode } = {};
    @Input() items: PayrollCode[];
    private _selectedError: IStatusMessage;
    @Input() public externalIntegration: boolean;
    @Input() public set selectedError(value: IStatusMessage) {
        if (!value) {
            return;
        }
        if (this._selectedError && this._selectedError.MsgEntityID) {
            const oldRow = document.getElementById(
                `row-${this._selectedError.MsgEntityID.toString()}`
            );
            if (oldRow) {
                oldRow.classList.remove('highlight');
                oldRow.classList.remove('highlight-warning');
                oldRow.classList.remove('highlight-danger');
            }
        }
        this._selectedError = value;
        if (!(value && value.MsgEntityID)) {
            return;
        }
        const row = document.getElementById(
            `row-${value.MsgEntityID.toString()}`
        );
        if (!row) {
            return;
        }
        row.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        row.classList.add('highlight');
        if (value.StatusCode === ResponseStatus.Warning) {
            row.classList.add('highlight-warning');
        }
        if (value.StatusCode === ResponseStatus.Failed) {
            row.classList.add('highlight-danger');
        }
    }
    public get selectedError(): IStatusMessage {
        return this._selectedError;
    }
    @Output() Save = new EventEmitter<PayrollCode[]>();
    @Output() Delete = new EventEmitter<PayrollCode>();
    @Output() Select = new EventEmitter<PayrollCode>();
    @Output() public ShowError = new EventEmitter<IShowErrors>();

    @Input() payrollCodesSelectItems: fromShared.SelectItem[];
    @Input() payrollCodesColumnHeaderSelectItems: fromShared.SelectItem[];
    @Input() payrollCodesDescSelectItems: fromShared.SelectItem[];

    onStatusClick(item: PayrollCode) {
        this.ShowError.emit({ open: true, MsgEntityID: item.id });
    }
    onRowEditInit(item: PayrollCode) {
        this.selected = [];
        this.cloned[item.id] = { ...item };
        this.editing = item;
    }
    onRowEditSave(item: PayrollCode) {
        item.Status = {
            StatusCode: ResponseStatus.Loading,
            Message: 'Saving'
        };

        this.Save.next([item]);
        delete this.cloned[item.id];
        delete this.editing;
    }
    onRowEditCancel(item: PayrollCode) {
        const index = this.items.findIndex(x => x.id === item.id);
        if (index >= 0) {
            this.items.splice(index, 1, this.cloned[item.id]);
        }
        this.items = [...this.items];
        this.selected = [];

        delete this.cloned[item.id];
        delete this.editing;
    }
    onRowDelete(item: PayrollCode) {
        item.Status = {
            StatusCode: ResponseStatus.Loading,
            Message: 'Deleting'
        };

        this.Delete.next(item);
    }
    onRowSelect($event) {
        this.Select.next($event.data);
    }
}
